// extracted by mini-css-extract-plugin
export default {"title":"BlogCard_title__A298B","description":"BlogCard_description__28rFo"};